<template>
  <div class="wrap">
    <div class="tab-wrap">
      <div
        class="tab-item"
        :class="{ active: activeIndex == 0 }"
        @click="handleRouter('/')"
      >
        <img
          class="icon home"
          :src="activeIndex == 0 ? iconHomeActive : iconHome"
          alt="首页"
        />
        <div class="text">首页</div>
      </div>
      <div class="tab-item" @click="handleAppClick(consultAppList[0])">
        <img
          class="icon search"
          :src="
            consultAppList.length > 0
              ? consultAppList[0].appIconFileUrl
              : iconAnswer
          "
          :alt="
            consultAppList.length > 0 ? consultAppList[0].appName : '智能咨询'
          "
        />
        <div
          class="text"
          v-text="
            consultAppList.length > 0 ? consultAppList[0].appName : '智能咨询'
          "
        ></div>
      </div>
      <div
        class="tab-item"
        :class="{ active: activeIndex == 1 }"
        @click="handleRouter('/user')"
      >
        <img
          class="icon user"
          :src="activeIndex == 1 ? iconUserActive : iconUser"
          alt="我的"
        />
        <div class="text">我的</div>
      </div>
    </div>
    <div class="out-circle" @click="handleAppClick(consultAppList[0])"></div>
    <div @click="handleAppClick(consultAppList[0])" class="in-circle">
      <div class="circle">
        <img
          class="icon search"
          :src="iconAnswer2"
          :alt="
            consultAppList.length > 0 ? consultAppList[0].appName : '智能咨询'
          "
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  thirdAppListGet,
  userAuth,
  usertestRequirmentCheck,
} from "@/api/common";
import { STATUS_CODE_OK, HEADER_TOKEN_NAME } from "@/config";
import { hasLoginCheck, queryStringParameter } from "@/utils";
export default {
  name: "MTabBar",
  props: {
    activeIndex: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      iconHome: require("@/assets/images/home.png"),
      iconHomeActive: require("@/assets/images/home-active.png"),
      iconUser: require("@/assets/images/user.png"),
      iconUserActive: require("@/assets/images/user-active.png"),
      iconAnswer: require("@/assets/images/answer.png"),
      iconAnswer2: require("@/assets/images/answer2.png"),
      consultAppList: [], // 智能咨询应用列表
      aIPermission: "N", // 旦小图Ai大模型访问权限
    };
  },
  computed: {
    ...mapGetters(["token"]),
  },
  watch: {
    token(val) {
      if (val) {
        this.handleTestPermissionCheck();
      }
    },
  },
  activated() {
    this.handleTestPermissionCheck();
  },
  created() {
    this.handleConsultAppListGet();
    this.handleTestPermissionCheck();
  },
  methods: {
    // 用户是否有AI大模型查看权限
    async handleTestPermissionCheck() {
      if (this.token) {
        const { data } = await usertestRequirmentCheck({
          requirement: "AI",
        });
        if (data.code === STATUS_CODE_OK) {
          this.aIPermission = data.data || "N";
        }
      } else {
        this.aIPermission = "N";
      }
    },
    // 获取智能咨询应用列表
    async handleConsultAppListGet() {
      const that = this;
      let { data } = await thirdAppListGet({
        appCategory: "4",
      });
      if (data.code === STATUS_CODE_OK) {
        that.consultAppList = data.data;
      }
    },
    // 路由跳转
    handleRouter(url) {
      this.$router.push(url);
    },
    // 点击第三方应用
    async handleAppClick(item) {
      const that = this;
      if (that.aIPermission == "Y") {
        // 需要用户授权
        hasLoginCheck({
          tip: "进入此应用前，请先登录",
          path: that.$route.fullPath,
          callBack: async () => {
            window.location.href = `${process.env.VUE_APP_BACK_END_API_PX_URL}/oauth/chainlith5auth?${HEADER_TOKEN_NAME}=${this.token}`;
          },
        });
      } else {
        if (item.appExtUserFlag === "Y") {
          // 需要用户授权
          hasLoginCheck({
            tip: "进入此应用前，请先登录",
            path: that.$route.fullPath,
            callBack: async () => {
              // 用户已经登录，则调用接口获取authCode
              let { data } = await userAuth({
                id: item.id,
              });
              if (data.code === STATUS_CODE_OK) {
                // 跳转到第三方应用
                window.location.href = queryStringParameter(
                  item.appRedirectUrl,
                  "authCode",
                  data.data.authCode
                );
              }
            },
          });
        } else {
          // 不需要用户授权
          if (item.routerFlag === "1") {
            // 内部url
            that.$router.push({
              path: item.appRedirectUrl,
            });
          } else {
            // 外部的url
            window.location.href = item.appRedirectUrl;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
.wrap {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 80px;
  z-index: 666;
  .tab-wrap {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 668;
    box-shadow: 0 -1px 3px #eee;
    background-color: #fff;
    padding: 5px 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .tab-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .icon {
        height: 20px;
        margin-bottom: 2px;
        &.home {
          height: 18px;
        }
      }
      .text {
        font-size: 12px;
        color: #666;
      }
      &.active {
        .text {
          color: #3770d3;
        }
      }
    }
  }
  .out-circle {
    width: 60px;
    height: 60px;
    position: absolute;
    top: 0;
    left: 50%;
    top: 0;
    z-index: 667;
    transform: translateX(-50%);
    box-shadow: 0 -1px 3px #eee;
    border-radius: 50%;
  }
  .in-circle {
    width: 60px;
    height: 60px;
    position: absolute;
    top: 0;
    left: 50%;
    top: 0;
    z-index: 669;
    transform: translateX(-50%);
    background-color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    .circle {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      .icon {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
